import styled, { keyframes } from "styled-components";

const fontColor = "#e5e5e5";

// Page
export const PageTemplate = styled.div`
  position: relative;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  width: 100%;
  overflow-x: hidden;
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 52px;
  line-height: 60px;
  font-weight: 900;
  color: ${fontColor};

  @media screen and (max-width: 1399px) {
    font-size: 30px;
    line-height: 36px;
  }
`;

export const PageSubtitle = styled.strong`
  margin-bottom: 20px;
  font-size: 24px;
  line-height: 20px;
  font-weight: 400;
  color: ${fontColor};
  @media screen and (max-width: 1399px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

// Section

export const SectionBox = styled.div`
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  width: 520px;
  margin: 60px 0;
  @media screen and (max-width: 1399px) {
    width: 100%;
    margin: 30px 0;
    padding: 0 10%;
  }
`;

export const SectionTitle = styled.span`
  font-size: 21px;
  line-height: 30px;
  font-weight: 900;
  color: ${fontColor};
  @media screen and (max-width: 1399px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const SectionArticle = styled.p`
  font-size: 17px;
  line-height: 30px;
  font-weight: 500;
  color: ${fontColor};
  @media screen and (max-width: 1399px) {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
  }
`;

export const SectionRemark = styled.span`
  margin: 0;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: ${fontColor};
  @media screen and (max-width: 1399px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const SectionMentWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  height: 150px;

  .wrap {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    width: calc(100% - 170px);
    height: 100%;
  }
  .ment {
    font-size: 17px;
    margin-bottom: 15px;
    color: ${fontColor};
  }
  .name {
    font-size: 14px;
    color: ${fontColor};
  }

  .wrap-img {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    width: 170px;
    height: auto;

    img {
      width: 170px;
      height: 150px;
    }
  }

  @media screen and (max-width: 800px) {
    .wrap-img {
      width: 100px;
      height: auto;

      img {
        width: 100%;
        height: auto;
      }
    }
    .wrap {
      width: calc(100% - 100px);
    }
    .ment {
      font-size: 15px;
    }
    .name {
      font-size: 13px;
    }
  }
`;

export const SectionByline = styled.div`
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  width: 520px;
  margin: 60px 0;

  .list {
    display: flex;
    flex-flow: column wrap;
    width: 100%;
    padding: 0;
    font-size: 16px;
    color: ${fontColor};
  }
  .row {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    width: 100%;
    height: 40px;
    padding: 5px 0;

    .row-name {
      flex: 1 1 50%;
      font-weight: 500;
    }
    .row-email {
      flex: 1 1 50%;
      font-weight: 500;
    }
  }

  @media screen and (max-width: 1399px) {
    width: 100%;
    margin: 30px 0;
    padding: 0 10%;
    .list {
      font-size: 14px;
    }
    .row {
      height: 30px;
      padding: 5px 0;
    }
  }
`;

// Map
export const MapDimmed = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
`;
export const MapWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  width: 100%;
  height: 700px;
  top: calc(50vh - 350px);
  left: 0;

  @media screen and (max-width: 1399px) {
    height: 600px;
    top: calc(50vh - 300px);
  }
`;
export const MapAbsolute = styled.div`
  position: absolute;
  width: 100%;
  height: 700px;
  top: 0;
  left: 0;
  @media screen and (max-width: 1399px) {
    z-index: 999;
    height: 600px;
  }

  @media screen and (max-width: 800px) {
    z-index: 999;
    height: 300px;
  }
`;
export const Map = styled.div`
  position: relative;
  width: 100%;
  height: 700px;
  @media screen and (max-width: 1399px) {
    height: 600px;
  }

  @media screen and (max-width: 800px) {
    width: 100%;
    height: 300px;
  }
`;

export const MapArticleWrapper = styled.div`
  z-index: 999;
  overflow-y: scroll;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;

  @media screen and (max-width: 800px) {
    z-index: 0;
    top: 300px;
    height: 100%;
  }
`;

export const MapArticleBox = styled.div`
  transform: translateX(calc(90vw - 540px));
  display: flex;
  flex-flow: column wrap;
  width: 540px;
  height: 680px;
  margin-bottom: 120px;
  padding: 60px;
  border: 3px solid #f2b749;
  background-color: rgba(38, 20, 27, 0.8);
  .title {
    font-size: 28px;
    font-weight: 700;
    line-height: 30px;
    margin: 10px 0;
    color: ${fontColor};
  }

  .chart {
    width: 100%;
    height: auto;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .text {
    font-size: 17px;
    line-height: 30px;
    color: ${fontColor};
  }

  &:first-child {
    margin-top: 200px;
  }

  &:last-child {
    margin-bottom: 800px;
  }

  @media screen and (max-width: 1399px) {
    z-index: 999;
    transform: translateX(calc(100vw - 420px));
    width: 400px;
    height: 600px;
    padding: 30px;

    .title {
      font-size: 24px;
      line-height: 24px;
      margin: 20px 0;
    }

    .chart {
      width: 90%;
    }

    .text {
      font-size: 16px;
      line-height: 24px;
      color: ${fontColor};
    }
  }

  @media screen and (max-width: 800px) {
    z-index: 0;
    transform: translateX(0);
    width: 100%;
    height: 400px;
    padding: 10px 20px;
    border-top: 2px solid #f2b749;
    border-bottom: 2px solid #f2b749;
    border-left: none;
    border-right: none;
    background-color: rgba(38, 20, 27, 1);
    .title {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
    }
    .chart {
      width: 60%;
      height: auto;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .text {
      font-size: 14px;
      color: ${fontColor};
    }
  }
`;

export const MapMarkerWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const MapMarker = styled.div`
  position: absolute;
  top: 40px;
  right: 30px;
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  width: 400px;
  height: 600px;
  padding: 30px;
  border: 3px solid #f2b749;
  background-color: rgba(38, 20, 27, 0.8);
  color: ${fontColor};

  .title {
    font-size: 24px;
    font-weight: 600;
  }

  .table {
    display: flex;
    flex-flow: column wrap;
    width: 100%;
    padding: 0;
    border-top: 2px solid #fff;
    border-bottom: 2px solid #fff;
  }
  .row {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    width: 100%;
    height: 40px;
    padding: 5px 0;
    font-size: 16px;

    .row-title {
      flex: 1 1 120px;
      font-weight: 700;
    }
    .row-text {
      flex: 1 1 calc(100% - 120px);
    }
  }
  .close {
    width: 100px;
    height: 40px;
    margin-top: 20px;
    border: 1px solid #ccc;
    color: ${fontColor};
  }
  @media screen and (max-width: 1399px) {
    top: 0px;
    right: 0;
    height: 580px;
    padding: 20px;
  }
  @media screen and (max-width: 800px) {
    z-index: 999;
    top: -100px;
    right: 0;
    width: 100%;
    .title {
      font-size: 16px;
    }
    .row {
      font-size: 14px;
    }
  }
`;

export const MapTitleWrapper = styled.div`
  position: relative;
  width: 100%;
`;
export const MapTitle = styled.div`
  z-index: 999;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  padding: 20px 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.4);
  .title {
    font-size: 18px;
    font-weight: 700;
    color: ${fontColor};
  }
  .remark {
    font-size: 14px;
    font-weight: 300;
    color: ${fontColor};
  }

  @media screen and (max-width: 1399px) {
    padding: 5px 10px;
    .title {
      font-size: 14px;
    }
  }
`;

export const MapColor = styled.div`
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 20px;
  background-color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
  font-weight: 700;
  .gahae {
    color: #f2b749;
    margin-right: 10px;
  }
  .pihae {
    color: #06bfbf;
  }
  .text {
    color: #fff;
  }
`;

export const ImageBridge = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  width: 100%;
  height: auto;
  margin: 30px 0;

  img {
    width: 520px;
    height: auto;
  }
  @media screen and (max-width: 800px) {
    margin: 10px 0;
    padding: 0 10%;

    img {
      width: 100%;
      height: auto;
    }
  }
`;

const pmAnimation = keyframes`
  0%{
    transform: translateX(-100vw);
  }
  30% {
    transform: translateX(0);
  }
  60% {
    transform: translateX(0);
  }
  100%{
    transform: translateX(calc(100vw + 200px));
  }
`;
export const TitleImage = styled.img`
  display: inline-block;
  width: 180px;
  height: auto;
  margin: 50px 0;
  animation: ${pmAnimation} 3s linear;

  @media screen and (max-width: 1399px) {
    width: 130px;
    height: auto;
  }
`;

export const CoverImage = styled.div`
  width: 100%;
  height: 450px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media screen and (max-width: 1399px) {
    height: 250px;
  }

  @media screen and (max-width: 800px) {
    height: 150px;
  }
`;
